import {
  type NshiftCreateSessionRequest,
  type NshiftCreateSessionResponse,
  type OldProductDTO
} from 'ecosystem'
import { computeFromStoreFrontOrderLines, nshiftApi } from 'api'
import { calculateOrderTotalWeight, getFullLocale } from 'shared-utils'
import * as productsApi from 'api/storefront-api/productsEndpoint'
import { type ShippingProviderOpts } from '../types'
import { type CarrierContext } from './types'

export const openNshiftSession = async (
  ctx: CarrierContext,
  opts: ShippingProviderOpts
): Promise<NshiftCreateSessionResponse> => {
  const { items, cartDiscountCode } = ctx.payload

  const fullProducts: OldProductDTO[] = await (async () => {
    const productIds = items?.map((item) => item.product.id) ?? []

    if (!productIds?.length) {
      return []
    }

    const productsResponse = await productsApi.listProductsFull(
      {
        productIds,
        ...(opts.customerId ? { customerId: opts.customerId } : {})
      },
      {
        size: productIds.length
      }
    )

    return productsResponse.content
  })()

  if (fullProducts.length !== items?.length) {
    throw new Error('Products are not found')
  }
  const { orderAmount } = computeFromStoreFrontOrderLines(items, cartDiscountCode)

  const { totalWeight, extendedItems } = calculateOrderTotalWeight(items, fullProducts)

  const payload: NshiftCreateSessionRequest = {
    currencyCode: opts.currencyCode,
    languageCode: ctx.locale,
    localeId: getFullLocale(ctx.locale),
    totalPrice: orderAmount,
    packages: [
      {
        weightKg: totalWeight,
        articles: extendedItems.map((item) => ({
          articleNo: item.product.articleNumber,
          quantity: item.quantity,
          weightKg: item.weight
        }))
      }
    ]
  }

  return nshiftApi.checkout.createSession(payload)
}
